import { Box, Dialog, IconButton } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import BackwardIcon from "../assets/images/Group 1561530081.svg";
import ForwardIcon from "../assets/images/Group 1561530080.svg";
import ResumeIcon from "../assets/images/Group 1561530073.svg";
import PauseIcon from "../assets/images/Group 1561530101.svg";
import useAutoHideControls from "../hooks/useAutoHideControls";
export default function VideoPlayer({ openVideoModal, handleClose, videoUrl }) {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showIcons, resetControls] = useAutoHideControls(isPlaying, 2500);

  const onClose = () => {
    videoRef.current?.pause();
    handleClose();
    setIsPlaying(false);
    resetControls();
  };

  const handleSkip = (seconds) => {
    if (videoRef.current) {
      videoRef.current.currentTime += seconds;
    }
  };

  const handleTogglePlayPause = () => {
    const video = videoRef.current;

    if (video) {
      if (isPlaying) {
        video.pause();
      } else {
        video.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <Dialog
      open={openVideoModal}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          width: "600px",
          height: "350px",
          position: "relative",
          //overflow: 'hidden',
        },
      }}
    >
      {openVideoModal && (
        <Box
          sx={{
            position: "absolute",
            top: "5px",
            right: "5px",
            zIndex: "999",
          }}
        >
          {console.log("oopen video modal is", openVideoModal)}
          <IconButton
            aria-label="close"
            //className={classes.closeButton}
            sx={{ backgroundColor: "#00000040" }}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      )}
      <video
        src={videoUrl}
        controls
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
        ref={videoRef}
        autoPlay
        onPlay={() => setIsPlaying(true)}
        onPause={() => {
          setIsPlaying(false);
          resetControls();
        }}
      ></video>

      {showIcons && (
        <>
          <img
            src={BackwardIcon}
            onClick={() => handleSkip(-10)}
            style={{
              width: "25px",
              height: "25px",
              position: "absolute",
              top: "50%",
              left: "30%",
              transform: "translateY(-50%)",
              cursor: "pointer",
            }}
          />
          <img
            src={isPlaying ? PauseIcon : ResumeIcon}
            onClick={handleTogglePlayPause}
            style={{
              width: "25px",
              height: "25px",
              position: "absolute",
              top: "50%",
              left: "48%",
              transform: "translateY(-50%)",
              cursor: "pointer",
            }}
          />
          {/* Forward Button */}
          <img
            src={ForwardIcon}
            onClick={() => handleSkip(10)}
            style={{
              width: "25px",
              height: "25px",
              position: "absolute",
              top: "50%",
              left: "65%",
              transform: "translateY(-50%)",
              cursor: "pointer",
            }}
          />
        </>
      )}
    </Dialog>
  );
}
